'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.waitForVendor = waitForVendor;

var _reduxSaga = require('redux-saga');

var _effects = require('redux-saga/effects');

var _Vendor = require('./Vendor.reducer');

var Vendor = _interopRequireWildcard(_Vendor);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(waitForVendor);

function waitForVendor(vendor) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3000;
  var start, hasExpired, isAvailable;
  return _regenerator2.default.wrap(function waitForVendor$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          start = Date.now();

        case 1:
          if (!__CLIENT__) {
            _context.next = 14;
            break;
          }

          _context.next = 4;
          return (0, _effects.select)(Vendor.hasLoadingExpired, vendor, timeout);

        case 4:
          hasExpired = _context.sent;
          _context.next = 7;
          return (0, _effects.select)(Vendor.isAvailable, vendor);

        case 7:
          isAvailable = _context.sent;

          if (!(hasExpired || isAvailable)) {
            _context.next = 10;
            break;
          }

          return _context.abrupt('return', isAvailable);

        case 10:
          _context.next = 12;
          return (0, _effects.race)([(0, _effects.take)(Vendor.setAvailable().type), (0, _effects.call)(_reduxSaga.delay, timeout - (Date.now() - start))]);

        case 12:
          _context.next = 1;
          break;

        case 14:
          return _context.abrupt('return', false);

        case 15:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}